<template>
  <div class="point_application_complete">
    <section class="text_center">
      <h2 class="header_underline">銀行振込決済(収納代行システム)<br>申込完了</h2>
      <p class="point_application_complete_notice">
        お客様へメールにてお振込み先のご案内が届いております。<br>
        URLをタップ後、表示される口座番号にお振込みいただくと自動でポイント追加されます。<br>
        ※メールは<span class="red--text">netbank@telecomcredit.co.jp</span>より届きます。<br>
        万が一メールが届かない場合は<a :href="`mailto:${settingData.inquiry_mail}?subject=お問い合わせ`" class="link_main--text">{{ settingData.inquiry_mail }}</a>にお問合せください。<br>
        ※URLへのアクセスは60分間有効です。60分を過ぎた場合は再度お申込みくださいませ。<br>
        ※稀に迷惑メールボックスに振り分けられることがございますので、メールが届かない場合はそちらもご確認ください。
      </p>
      <p>
        <router-link :to="{ name: 'PointPurchase' }" class="arrow link_main--text">ポイント購入ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointBankTelecomApplicationComplete',
  data () {
    return {
      settingData: []
    }
  },
  methods: {
    getDefaultSetting () {
      this.$store.dispatch('getDefaultSetting')
        .then((data) => {
          this.settingData = data
        })
    }
  },
  created () {
    this.getDefaultSetting()
  }
}
</script>
